import { render, staticRenderFns } from "./BulkLocation.vue?vue&type=template&id=ad0124d6&scoped=true&"
import script from "./BulkLocation.vue?vue&type=script&lang=js&"
export * from "./BulkLocation.vue?vue&type=script&lang=js&"
import style0 from "./BulkLocation.vue?vue&type=style&index=0&id=ad0124d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0124d6",
  null
  
)

export default component.exports